<template>
    <div>

        <h4 class="mb-6">Movies</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addMoviePrompt = true">Add</vs-button>

        <vx-card>

            <vs-table id="table" ref="table" @selected="openMovie" pagination search :data="tableData" :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th v-if="tmdbConfig">Poster</vs-th>
                    <vs-th sort-key="title">Title</vs-th>
                    <vs-th sort-key="release_date">Release date</vs-th>
                    <vs-th sort-key="added_time">Added time</vs-th>
                    <vs-th sort-key="runtime">Runtime</vs-th>
                    <vs-th sort-key="ratings">Ratings</vs-th>
                    <vs-th sort-key="movie_type_string">Type</vs-th>
                    <vs-th sort-key="worker_name">Worker</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td v-if="tmdbConfig" :data="data[index].poster_path">
                            <img :src="tmdbConfig.secure_base_url + 'w154' + data[index].poster_path" style="width: 52px"/>
                        </vs-td>

                        <vs-td :data="data[index].title">
                            {{ data[index].title }}
                        </vs-td>

                        <vs-td :data="data[index].release_date">
                            {{ moment(data[index].release_date).format("YYYY/MM/DD") }}
                        </vs-td>

                        <vs-td :data="data[index].added_time">
                            {{ moment(data[index].added_time).format("YYYY/MM/DD HH:mm") }}
                        </vs-td>

                        <vs-td :data="data[index].runtime">
                            {{ data[index].runtime }}
                        </vs-td>

                        <vs-td :data="data[index].ratings">
                            {{ data[index].ratings }}
                        </vs-td>

                        <vs-td :data="data[index].movie_type_string">
                            {{ data[index].movie_type_string }}
                        </vs-td>

                        <vs-td :data="data[index].worker_name">
                            {{ data[index].worker_name }}
                        </vs-td>

                    </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

        <vs-popup title="Add movie" :active.sync="addMoviePrompt">
            <div id="addMovieDiv" class="vs-con-loading__container" >
                <p>Worker</p>
                <vs-select autocomplete class="w-full" v-model="addObject['worker_id']">
                    <vs-select-item :key="key" :value="key" :text="item" v-for="(item, key) in workers" />
                </vs-select>
                <p class="mt-6">Movie folder</p>
                <vs-input v-model="addObject['movie_folder']" class="w-full"/>
                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <p class="mt-6">Player file</p>
                        <vs-input v-model="addObject['player_file']" class="w-full"/>
                    </div>
                    <div class="vx-col w-1/2">
                        <p class="mt-6">Movie type</p>
                        <vs-select autocomplete class="w-full" v-model="addObject['movie_type']">
                            <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in ['Progressive', 'HLS', 'DASH', 'Smooth Streaming']" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <p class="mt-6">TMDB ID</p>
                        <vx-input-group class="mb-base">
                            <vs-input v-model="addObject['tmdb_id']" class="w-full"/>

                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button color="primary" icon-pack="feather" icon="icon-search" @click="findMovie"/>
                                </div>
                            </template>
                        </vx-input-group>
                    </div>
                    <div class="vx-col w-1/2">
                        <p class="mt-6">IMDB ID</p>
                        <vs-input v-model="addObject['imdb_id']" class="w-full"/>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <p>Title</p>
                        <vs-input v-model="addObject['title']" class="w-full"/>
                    </div>
                    <div class="vx-col w-1/2">
                        <p>Tagline</p>
                        <vs-input v-model="addObject['tagline']" class="w-full"/>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/2">
                        <p class="mt-6">Poster path</p>
                        <vs-input v-model="addObject['poster_path']" class="w-full"/>
                        <img v-if="tmdbConfig && addObject['poster_path'].length > 0" :src="tmdbConfig.secure_base_url + 'w342' + addObject['poster_path']" class="w-full mt-3 rounded-lg"/>
                    </div>
                    <div class="vx-col w-1/2">
                        <p class="mt-6">Backdrop path</p>
                        <vs-input v-model="addObject['backdrop_path']" class="w-full"/>
                        <img v-if="tmdbConfig && addObject['backdrop_path'].length > 0" :src="tmdbConfig.secure_base_url + 'w300' + addObject['backdrop_path']" class="w-full mt-3 rounded-lg"/>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-1/3">
                        <p class="mt-6">Release date</p>
                        <flat-pickr :config="configDateTimePicker" v-model="addObject['release_date']" class="w-full"></flat-pickr>
                    </div>
                    <div class="vx-col w-1/3">
                        <p class="mt-6">Runtime</p>
                        <vs-input v-model="addObject['runtime']" class="w-full"/>
                    </div>
                    <div class="vx-col w-1/3">
                        <p class="mt-6">Ratings</p>
                        <vs-input v-model="addObject['ratings']" class="w-full"/>
                    </div>
                </div>

                <p class="mt-6">Genres</p>
                <vs-chips color="rgb(145, 32, 159)" placeholder="Add genre" v-model="addObject['genres']">
                    <vs-chip
                        :key="genre"
                        @click="removeGenre(genre)"
                        v-for="genre in addObject['genres']" closable>
                        {{ genre }}
                    </vs-chip>
                </vs-chips>

                <p class="mt-6">Overview</p>
                <vs-textarea v-model="addObject['overview']" class="w-full"/>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addMovie">Add</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'

    export default {
        components: {
            flatPickr
        },
        data(){
            return {
                itemsPerPage: 100,
                isMounted: false,

                movies: [],
                addMoviePrompt: false,

                tmdbConfig: null,

                addObject: {
                    tmdb_id: "",
                    imdb_id: "",
                    title: "",
                    tagline: "",
                    poster_path: "",
                    backdrop_path: "",
                    release_date: "",
                    runtime: "",
                    ratings: "",
                    overview: "",
                    genres: [],
                },

                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    time_24hr: false,
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                workers: {},
            }
        },
        methods: {
            removeGenre(genre) {
                for( let i = 0; i < this.addObject['genres'].length; i++){ if ( this.addObject['genres'][i] === genre) { this.addObject['genres'].splice(i, 1); }}
            },
            loadData(){
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/vod/movie/')
                loadPromise.then(function(response) {
                    thisIns.movies = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const tmdbConfigPromise = this.$http.get('/api/management/v1/tmdb/config')
                tmdbConfigPromise.then(function(response) {
                    thisIns.tmdbConfig = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const workersPromise = this.$http.get('/api/management/v1/worker/?type=names')
                workersPromise.then(function(response) {
                    thisIns.workers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, tmdbConfigPromise, workersPromise]).finally(function (){
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            addMovie(){
                this.$vs.loading({
                    container: '#addMovieDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/vod/movie/', {
                    worker_id: Number(this.addObject.worker_id),
                    movie_folder: this.addObject.movie_folder,
                    player_file: this.addObject.player_file,
                    movie_type: Number(this.addObject.movie_type),
                    tmdb_id: this.addObject.tmdb_id,
                    imdb_id: this.addObject.imdb_id,
                    title: this.addObject.title,
                    tagline: this.addObject.tagline,
                    poster_path: this.addObject.poster_path,
                    backdrop_path: this.addObject.backdrop_path,
                    release_date: this.moment(this.addObject.release_date).format(),
                    runtime: this.addObject.runtime,
                    ratings: this.addObject.ratings,
                    overview: this.addObject.overview,
                    genres: this.addObject.genres
                })

                addPromise.then(function(response) {
                    thisIns.addMoviePrompt = false
                    thisIns.$printSuccess('Movie added')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/movie/' + response.data.id)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addMovieDiv > .con-vs-loading')
                })
            },
            findMovie(){
                this.$vs.loading({
                    container: '#addMovieDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/tmdb/find/' + this.addObject.tmdb_id)
                loadPromise.then(function(response) {
                    let oldObject = thisIns.addObject
                    thisIns.addObject = response.data
                    thisIns.addObject.worker_id = oldObject.worker_id
                    thisIns.addObject.movie_folder = oldObject.movie_folder
                    thisIns.addObject.player_file = oldObject.player_file
                    thisIns.$printSuccess("Movie found!")
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function (){
                    thisIns.$vs.loading.close('#addMovieDiv > .con-vs-loading')
                })
            },
            openMovie(tr) {
                this.$router.push('/movie/' + tr.id)
            },
            movieTypeToString(type){
                switch (type){
                    case 0: return "Progressive";
                    case 1: return "HLS";
                    case 2: return "DASH";
                    case 3: return "Smooth Streaming";
                    default: return "Unknown";
                }

            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                let finalMovies = JSON.parse(JSON.stringify(this.movies));
                for(let i = 0; i < finalMovies.length; i++) finalMovies[i].movie_type_string = this.movieTypeToString(finalMovies[i].movie_type);
                return finalMovies
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addMoviePrompt) {
                this.addMoviePrompt = false
                next(false)
            } else {
                next()
            }
        }
    }
</script>
